import { ExternalAssetSearchDto } from '@unistocks/proxy/axios-client';
import { Option, SelectOption } from '@unistocks/types';
import { HasId, HasValue } from '@unistocks/types/has-id';

export function extractId<T extends HasId>({ id }: T) {
  return id;
}

export function extractOptionId<T extends SelectOption<HasId>>({ value: { id } }: T) {
  return id;
}

export function extractOptionValue<T = any>({ value }: HasValue<T>): T {
  return value;
}

export function extractSymbol({ value: assetSearchResult }: Option<ExternalAssetSearchDto>) {
  return assetSearchResult.symbol!;
}
